export const GET_LANGUAGES_REQUEST = "GET_LANGUAGES_REQUEST";
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_FAILURE = "GET_LANGUAGES_FAILURE";

export const GET_COUNTRY_REQUEST = "GET_COUNTRY_REQUEST";
export const GET_COUNTRY_SUCCESS = "GET_COUNTRY_SUCCESS";
export const GET_COUNTRY_FAILURE = "GET_COUNTRY_FAILURE";

export const GET_TIME_ZONES_REQUEST = "GET_TIME_ZONES_REQUEST";
export const GET_TIME_ZONES_SUCCESS = "GET_TIME_ZONES_SUCCESS";
export const GET_TIME_ZONES_FAILURE = "GET_TIME_ZONES_FAILURE";

export const GET_WEBSITE_LANGUAGE_DATA_REQUEST = "GET_WEBSITE_LANGUAGE_DATA_REQUEST";
export const GET_WEBSITE_LANGUAGE_DATA_SUCCESS = "GET_WEBSITE_LANGUAGE_DATA_SUCCESS";
export const GET_WEBSITE_LANGUAGE_DATA_FAILURE = "GET_WEBSITE_LANGUAGE_DATA_FAILURE";

export const GET_CURRENCY_REQUEST = "GET_CURRENCY_REQUEST";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
export const GET_CURRENCY_FAILURE = "GET_CURRENCY_FAILURE";

export const GET_PHYSICIAN_SERVICE_REQUEST = "GET_PHYSICIAN_SERVICE_REQUEST";
export const GET_PHYSICIAN_SERVICE_SUCCESS = "GET_PHYSICIAN_SERVICE_SUCCESS";
export const GET_PHYSICIAN_SERVICE_FAILURE = "GET_PHYSICIAN_SERVICE_FAILURE";

export const POST_REGISTER_USER_REQUEST = "POST_REGISTER_USER_REQUEST";
export const POST_REGISTER_USER_SUCCESS = "POST_REGISTER_USER_SUCCESS";
export const POST_REGISTER_USER_FAILURE = "POST_REGISTER_USER_FAILURE";

export const POST_VERIFY_OTP_REQUEST = "POST_VERIFY_OTP_REQUEST";
export const POST_VERIFY_OTP_SUCCESS = "POST_VERIFY_OTP_SUCCESS";
export const POST_VERIFY_OTP_FAILURE = "POST_VERIFY_OTP_FAILURE";

export const POST_SIGN_IN_REQUEST = "POST_SIGN_IN_REQUEST";
export const POST_SIGN_IN_SUCCESS = "POST_SIGN_IN_SUCCESS";
export const POST_SIGN_IN_FAILURE = "POST_SIGN_IN_FAILURE";

export const POST_FORGOT_PASSWORD_REQUEST = "POST_FORGOT_PASSWORD_REQUEST";
export const POST_FORGOT_PASSWORD_SUCCESS = "POST_FORGOT_PASSWORD_SUCCESS";
export const POST_FORGOT_PASSWORD_FAILURE = "POST_FORGOT_PASSWORD_FAILURE";

export const POST_PROFILE_IMAGE_REQUEST = "POST_PROFILE_IMAGE_REQUEST";
export const POST_PROFILE_IMAGE_SUCCESS = "POST_PROFILE_IMAGE_SUCCESS";
export const POST_PROFILE_IMAGE_FAILURE = "POST_PROFILE_IMAGE_FAILURE";

export const POST_CHANGE_PASSWORD_REQUEST = "POST_CHANGE_PASSWORD_REQUEST";
export const POST_CHANGE_PASSWORD_SUCCESS = "POST_CHANGE_PASSWORD_SUCCESS";
export const POST_CHANGE_PASSWORD_FAILURE = "POST_CHANGE_PASSWORD_FAILURE";

export const POST_UPLOAD_PDF_REQUEST = "POST_UPLOAD_PDF_REQUEST";
export const POST_UPLOAD_PDF_SUCCESS = "POST_UPLOAD_PDF_SUCCESS";
export const POST_UPLOAD_PDF_FAILURE = "POST_UPLOAD_PDF_FAILURE";

export const POST_API_GET_AUTH_TOKEN_REQUEST = "POST_API_GET_AUTH_TOKEN_REQUEST";
export const POST_API_GET_AUTH_TOKEN_SUCCESS = "POST_API_GET_AUTH_TOKEN_SUCCESS";
export const POST_API_GET_AUTH_TOKEN_FAILURE = "POST_API_GET_AUTH_TOKEN_FAILURE";

const actionTypeCommon = {
    GET_LANGUAGES_REQUEST,
    GET_LANGUAGES_SUCCESS,
    GET_LANGUAGES_FAILURE,

    GET_COUNTRY_REQUEST,
    GET_COUNTRY_SUCCESS,
    GET_COUNTRY_FAILURE,

    GET_TIME_ZONES_REQUEST,
    GET_TIME_ZONES_SUCCESS,
    GET_TIME_ZONES_FAILURE,

    GET_WEBSITE_LANGUAGE_DATA_REQUEST,
    GET_WEBSITE_LANGUAGE_DATA_SUCCESS,
    GET_WEBSITE_LANGUAGE_DATA_FAILURE,

    GET_CURRENCY_REQUEST,
    GET_CURRENCY_SUCCESS,
    GET_CURRENCY_FAILURE,

    GET_PHYSICIAN_SERVICE_REQUEST,
    GET_PHYSICIAN_SERVICE_SUCCESS,
    GET_PHYSICIAN_SERVICE_FAILURE,

    POST_REGISTER_USER_REQUEST,
    POST_REGISTER_USER_SUCCESS,
    POST_REGISTER_USER_FAILURE,

    POST_VERIFY_OTP_REQUEST,
    POST_VERIFY_OTP_SUCCESS,
    POST_VERIFY_OTP_FAILURE,

    POST_SIGN_IN_REQUEST,
    POST_SIGN_IN_SUCCESS,
    POST_SIGN_IN_FAILURE,

    POST_FORGOT_PASSWORD_REQUEST,
    POST_FORGOT_PASSWORD_SUCCESS,
    POST_FORGOT_PASSWORD_FAILURE,

    POST_PROFILE_IMAGE_REQUEST,
    POST_PROFILE_IMAGE_SUCCESS,
    POST_PROFILE_IMAGE_FAILURE,

    POST_CHANGE_PASSWORD_REQUEST,
    POST_CHANGE_PASSWORD_SUCCESS,
    POST_CHANGE_PASSWORD_FAILURE,

    POST_UPLOAD_PDF_REQUEST,
    POST_UPLOAD_PDF_SUCCESS,
    POST_UPLOAD_PDF_FAILURE,

    POST_API_GET_AUTH_TOKEN_REQUEST,
    POST_API_GET_AUTH_TOKEN_SUCCESS,
    POST_API_GET_AUTH_TOKEN_FAILURE

};

export default actionTypeCommon;
